import React, { createContext, useState, useContext } from "react";
import DownloadAppPage from "../Pages/ResponsivePages/DownloadAppPage";

const DownloadAppContext = createContext<any>(null);

export const useDownloadApp = () => useContext(DownloadAppContext);

export const DownloadAppProvider = ({ children }: { children: React.ReactNode }) => {
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);

  return (
    <DownloadAppContext.Provider value={{ showDownloadPopup, setShowDownloadPopup }}>
      {children}
      {showDownloadPopup && (
        <DownloadAppPage onClose={() => setShowDownloadPopup(false)} />
      )}
    </DownloadAppContext.Provider>
  );
};
